import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Comparison() {
  return <section className="py-24 bg-gray-50 border-y-4 border-black" data-id="element-23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-25">
          <h2 className="text-4xl md:text-5xl font-black mb-4" data-id="element-26">
            Why Pay More? Compare and Save.
          </h2>
          <div className="w-24 h-2 bg-black mx-auto" data-id="element-27"></div>
        </motion.div>

        <div className="flex flex-col md:flex-row gap-8 max-w-5xl mx-auto items-center" data-id="element-28">
          {/* Other Guys */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 w-full bg-white border-4 border-gray-300 p-8 opacity-80" data-id="element-29">
            <h3 className="text-2xl font-black text-gray-500 mb-6 text-center" data-id="element-30">
              The Other Guys
            </h3>
            <ul className="space-y-6" data-id="element-31">
              {['High 100+ minimums', 'Slow 2-3 week turnaround', 'Limited product options', 'Overseas printing'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-500 font-medium text-lg" data-id="element-32">
                  <X className="w-6 h-6 text-gray-400 flex-shrink-0" strokeWidth={3} data-id="element-33" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* Us */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 w-full bg-black text-white border-4 border-black p-8 md:scale-110 relative z-10 shadow-2xl" data-id="element-34">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-white text-black px-4 py-1 font-display font-black uppercase tracking-widest text-sm border-2 border-black" data-id="element-35">
              Best Value
            </div>
            <h3 className="text-3xl font-black mb-6 text-center" data-id="element-36">
              Strata Custom Apparel
            </h3>
            <ul className="space-y-6 mb-8" data-id="element-37">
              {['Low 24-piece minimums', 'Fast 5-7 day turnaround', 'Shirts, polos, hats & more', 'Printed IN HOUSE in San Diego, CA'].map((item, i) => <li key={i} className="flex items-center gap-3 font-bold text-xl" data-id="element-38">
                  <Check className="w-6 h-6 text-white flex-shrink-0" strokeWidth={4} data-id="element-39" />
                  {item}
                </li>)}
            </ul>
            <motion.button onClick={() => document.getElementById('quote-form')?.scrollIntoView({
            behavior: 'smooth'
          })} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full bg-white text-black py-4 font-display font-black uppercase tracking-widest text-lg hover:bg-gray-200 transition-colors" data-id="element-40">
              Get a Fast Quote
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>;
}